import * as mock from "../mockup/mockup";
import axios from "axios";

const getPackageList = async () => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");
  return await axios.get(`${apiUrl}/sdk_getuserorderlist.jsp`, {
    params: {
      producttype: 0
    }
  });
};

const getProductDetails = async (codes) => {
  var sessionID = localStorage.getItem("sessionid");
  var apiUrl = localStorage.getItem("interfaceurl");
  return await axios.get(`${apiUrl}/sdk_getupdateproduct.jsp`, {
    params: {
      productcode: codes
    }
  });
};

const getUserVersionInfo = async () => {
  return await new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mock.userVersion);
    }, 400);
  });
};

const updateNotificationPreferences = async (
  enableCampaignNotifications,
  enableContentNotifications
) => {
  return await axios.post("/notifications/update-preferences", {
    EnableCampaignNotifications: !!enableCampaignNotifications,
    EnableContentNotifications: !!enableContentNotifications
  });
};

const getSubscriberDevices = async () => {
  return await axios.get("/subscriber/devices");
};

const deactivateSubscriberDevice = async (deviceUId) => {
  return await axios.post(
    `/subscriber/deactivate-device?deviceUId=${encodeURIComponent(deviceUId)}`
  );
};

const getSubscriberInfo = async () => {
  return await axios.get("/subscriber");
};

const getSubscriptions = async () => {
  return await axios.get("/subscriptions");
};

export {
  getUserVersionInfo,
  getPackageList,
  getProductDetails,
  updateNotificationPreferences,
  getSubscriberDevices,
  deactivateSubscriberDevice,
  getSubscriberInfo,
  getSubscriptions
};
